import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import Route from './route';
import ScrollToTop from './scrollToTop';

import SignIn from '../pages/SignIn';
import SignUp from '../pages/SignUp';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';

import Home from '../pages/Dashboard';
import SearchProperty from '../pages/Search/Property';
import SearchUser from '../pages/Search/User';
import Profile from '../pages/Profile';
import EditProfile from '../pages/Profile/Edit';
import UpdatePassword from '../pages/Profile/UpdatePassword';
import Help from '../pages/Help';

import Property from '../pages/Property';
import NewProperty from '../pages/Property/New';
import EditProperty from '../pages/Property/Edit';
import ManageImages from '../pages/Property/ManageImages';
import Contributors from '../pages/Property/Contributors';
import ExportData from '../pages/Property/ExportData';
import Breeds from '../pages/Property/Breeds';
import Categories from '../pages/Property/Categories';

import Notifications from '../pages/Property/Transferences/ViewAll';
import SelectTransferenceAnimals from '../pages/Property/Transferences/SelectAnimals';
import SendTransferenceAnimals from '../pages/Property/Transferences/SendAnimals';

import User from '../pages/User';

import NewAnimal from '../pages/Animal/New';
import EditAnimal from '../pages/Animal/Edit';
import SearchAnimal from '../pages/Animal/Search';
import SearchAnimalDetails from '../pages/Animal/Search/Details';
import Animal from '../pages/Animal';
import AnimalSiblings from '../pages/Animal/Siblings';
import AnimalSons from '../pages/Animal/Sons';

import NewRegister from '../pages/Register/New';
import EditRegister from '../pages/Register/Edit';
import Registers from '../pages/Register/Search';

import Sync from '../pages/Sync';

const Routes: React.FC = () => {
  return (
    <ScrollToTop>
      <Switch>
        <Route exact path="/" component={() => <Redirect to="/login" />} />
        <Route exact path="/login" component={SignIn} />
        <Route exact path="/cadastro" component={SignUp} />
        <Route exact path="/recuperar" component={ForgotPassword} />
        <Route exact path="/nova-senha" component={ResetPassword} />

        <Route exact path="/ajuda" component={Help} isPrivate />

        <Route exact path="/inicio" component={Home} isPrivate />
        <Route
          exact
          path="/pesquisar/propriedade"
          component={SearchProperty}
          isPrivate
        />
        <Route
          exact
          path="/pesquisar/usuario"
          component={SearchUser}
          isPrivate
        />
        <Route exact path="/perfil" component={Profile} isPrivate />

        <Route exact path="/perfil/editar" component={EditProfile} isPrivate />
        <Route
          exact
          path="/perfil/editar/senha"
          component={UpdatePassword}
          isPrivate
        />

        <Route
          exact
          path="/propriedade/nova"
          component={NewProperty}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/editar/:id"
          component={EditProperty}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/imagens/:id"
          component={ManageImages}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/colaboradores/:id"
          component={Contributors}
          isPrivate
        />
        <Route exact path="/propriedade/:id" component={Property} isPrivate />
        <Route
          exact
          path="/propriedade/:id/racas"
          component={Breeds}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id/categorias"
          component={Categories}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/exportar"
          component={ExportData}
          isPrivate
        />
        <Route exact path="/notificacoes" component={Notifications} isPrivate />
        <Route
          exact
          path="/propriedade/:id_property/transferencias/selecionar"
          component={SelectTransferenceAnimals}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/transferencias/enviar"
          component={SendTransferenceAnimals}
          isPrivate
        />

        <Route
          exact
          path="/propriedade/:id_property/animais/novo"
          component={NewAnimal}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/animais/pesquisar"
          component={SearchAnimal}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/animais/pesquisar/detalhes"
          component={SearchAnimalDetails}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/animais/:id_animal"
          component={Animal}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/animais/:id_animal/editar"
          component={EditAnimal}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/animais/:id_animal/irmaos"
          component={AnimalSiblings}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/animais/:id_animal/filhos"
          component={AnimalSons}
          isPrivate
        />

        <Route
          exact
          path="/propriedade/:id_property/animais/:id_animal/registros/novo"
          component={NewRegister}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/animais/:id_animal/registros"
          component={Registers}
          isPrivate
        />
        <Route
          exact
          path="/propriedade/:id_property/animais/:id_animal/registros/:id_register/editar"
          component={EditRegister}
          isPrivate
        />

        <Route exact path="/usuario/:id" component={User} isPrivate />

        <Route exact path="/sincronizacao" component={Sync} isPrivate />
      </Switch>
    </ScrollToTop>
  );
};

export default Routes;
